<template>
    <div class="field">
        <label class="label">{{ $t("misc.frequencyHeader") }}</label>
        <div class="control">
            <div class="columns is-vcentered">
                <div class="column">
                    <b-button class="time-interval-button" @click="setTimeInterval('daily')"
                        v-bind:class="{ 'is-primary': timeInterval == 'daily' }">
                        {{ $t("misc.daily") }}
                    </b-button>
                    <b-button class="time-interval-button" @click="setTimeInterval('weekly')"
                        v-bind:class="{ 'is-primary': timeInterval == 'weekly' }">
                        {{ $t("misc.weekly") }}
                    </b-button>
                    <b-button class="time-interval-button" @click="setTimeInterval('monthly')"
                        v-bind:class="{ 'is-primary': timeInterval == 'monthly' }">
                        {{ $t("misc.monthly") }}
                    </b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "FrequencyField",
    data: function () {
        return {
            timeInterval: 'daily'
        }
    },
    methods: {
        setTimeInterval(interval) {
            this.timeInterval = interval;
        }
    }
}

</script>

<style scoped>
.time-interval-button {
    margin-right: 16px;
}

@media only screen and (max-width: 768px) {
    .time-interval-button {
        width: 100%;
        margin-right: 0px !important;
        margin-bottom: 0.5rem;
    }
}
</style>